import React, { createContext, useReducer, useContext, useCallback, Dispatch } from 'react';
import { message } from 'antd';
import {
    getRewardRedeemCoupon,
    getRewardRedeemRule,
    queryFreeProductList,
    queryFreeProductRuleList,
    queryThirdCouponList,
    queryThirdCouponRuleList,
    queryActivetyList,
    queryIssuedThirdCouponList,
    checkBlacklist,
} from '@/service';
import { FormatMoney } from '@/utils';
import { formatLocalTime } from '@/utils/timeConversionTool';
export interface EcoState {
    // 是否在黑名单中
    inBlackList: boolean;
    // 用户积分详情
    userPointsInfo: {
        accumPoints: string;
        frozenPoints: string;
        points: string;
        sign: string;
        userId: string;
        version: number;
    } | null;
    // 积分兑换规则
    COUPONS_RULES: any[];
    FREE_PRODUCTS_RULES: any[];
    THIRD_COUPONS_RULES: any[];
    // 积分兑换规则 存在url模式 临时加的 欧洲会员需要存在两个这个模块 时间紧任务重
    COUPONS_RULES_URL: any[];
    FREE_PRODUCTS_RULES_URL: any[];
    THIRD_COUPONS_RULES_URL: any[];

    // 已兑换券
    COUPONS_REDEEMED: any[];
    FREE_PRODUCTS_REDEEMED: any[];
    THIRD_COUPONS_REDEEMED: any[];

    // Issued 第三方
    ISSEUED_THIRD_COUPONS_REDEEMED: any[];

    // 活动
    LUCKY_ACTIVE?: any;
}

type FormatMap = { [key: string]: string };

export const dateFormatMap: FormatMap = {
    us: 'MM/DD/YYYY',
    ca: 'MM/DD/YYYY',
    jp: 'YYYY/MM/DD',
};

export const dateTimeFormatMap: FormatMap = {
    us: 'MM/DD/YYYY HH:mm:ss',
    ca: 'MM/DD/YYYY HH:mm:ss',
    jp: 'YYYY/MM/DD HH:mm:ss',
};

// 给coupon添加Notes
const injectNotes = (coupon: any[], locale: string, t: any, timezoneList?: any) => {
    return coupon?.map((coupon: any) => {
        const noteList: string[] = [t('site_rules'), t('order_rule')];

        // 不找零
        if (coupon?.prerequisite !== 'PRICES' && coupon?.discountType === 'fixed_amount') {
            noteList.push(t('purchas_rule'));
        }
        if (coupon?.prerequisite === 'PRICES' && coupon?.discountType === 'fixed_amount') {
            const couponPrice = parseInt(coupon?.amount);
            const priceRange = parseInt(coupon.prerequisiteRange);
            if (priceRange < couponPrice) {
                noteList.push(t('purchas_rule'));
            }
        }
        if (coupon?.goodId) noteList.push(t('product_rules', { product: coupon?.goodTitle || '' }));

        // 最低金额
        if (coupon?.prerequisite === 'PRICES') {
            const price = parseInt(coupon.prerequisiteRange);
            const currencySymbol = coupon?.currencySymbol || '';
            const prerequisiteRange = t('minimum_price', { price: currencySymbol + FormatMoney(price) });
            noteList.push(prerequisiteRange);
        }

        // 最低数量
        if (coupon?.prerequisite === 'QUANTITY') {
            const num = parseInt(coupon.prerequisiteRange);
            const prerequisiteRange = t('minimum_num', { num });
            noteList.push(prerequisiteRange);
        }

        // 过期天数
        const limitDay = Math.floor((coupon?.expiredDay || 0) / 60 / 24);
        if (coupon?.expiredFlag && coupon?.expiredType === 'DAY') {
            noteList.push(t('days_rules', { days: limitDay }));
        }
        // 时间 for 福利中心
        if (coupon?.couponId && coupon?.endTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            // const startTime = moment(Number(coupon?.startTime)).format(formater);
            // const endTime = moment(Number(coupon?.endTime)).format(formater);
            const startTime = formatLocalTime(coupon?.startTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.endTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // 时间 for 优惠券
        if (coupon?.coupon && coupon?.endTime) {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            // const startTime = moment(Number(coupon?.startTime)).format(formater);
            // const endTime = moment(Number(coupon?.endTime)).format(formater);
            const startTime = formatLocalTime(coupon?.startTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.endTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // 时间 for 优惠券规则
        if (!(coupon?.coupon || coupon?.couponId) && coupon?.expiredFlag && coupon?.validEndTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            // const startTime = moment(Number(coupon?.validStartTime)).format(formater);
            // const endTime = moment(Number(coupon?.validEndTime)).format(formater);
            const startTime = formatLocalTime(coupon?.validStartTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.validEndTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // campaign限时型时间
        if (!coupon?.discountId && coupon?.campaignStartTime && coupon?.campaignEndTime) {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            // const startTime = moment(Number(coupon?.campaignStartTime)).format(formater);
            // const endTime = moment(Number(coupon?.campaignEndTime)).format(formater);
            const startTime = formatLocalTime(coupon?.campaignStartTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.campaignEndTime, timezoneList, formater);
            noteList.push(t('campaign_time_limit_text', { startTime, endTime }));
        }
        // 临时新增规则 只针对这一个优惠券
        if (coupon?.discountId && coupon?.discountId === '1698949120957939713') {
            noteList.push('*단순 개봉 제품');
        }
        if (coupon?.extRuleDesc) {
            noteList.push(coupon?.extRuleDesc);
        }
        return { ...coupon, showMore: false, noteList };
    });
};

export enum EcoTypes {
    changeBlackList = 'changeBlackList',
    GET_COUPONS_RULES = 'GET_COUPONS_RULES_TYPES',
    GET_FREE_PRODUCTS_RULES = 'GET_FREE_PRODUCTS_RULES_TYPES',
    GET_THIRD_COUPONS_RULES = 'GET_THIRD_COUPONS_RULES_TYPES',
    GET_COUPONS_RULES_URL = 'GET_COUPONS_RULES_TYPES_URL',
    GET_FREE_PRODUCTS_RULES_URL = 'GET_FREE_PRODUCTS_RULES_TYPES_URL',
    GET_THIRD_COUPONS_RULES_URL = 'GET_THIRD_COUPONS_RULES_TYPES_URL',
    GET_COUPONS_REDEEMED = 'GET_COUPONS_REDEEMED_TYPES',
    GET_FREE_PRODUCTS_REDEEMED = 'GET_FREE_PRODUCTS_REDEEMED_TYPES',
    GET_THIRD_COUPONS_REDEEMED = 'GET_TTHIRD_COUPONS_REDEEMED_TYPES',
    GET_ISSUED_THIRD_COUPONS_REDEEMED = 'GET_ISSUED_THIRD_COUPONS_REDEEMED',
    GET_ACTIVE_LIST = 'GET_ACTIVE_LIST_TYPES',
}

export interface EcoAction {
    type: string;
    payload: any;
}

const initState: EcoState = {
    inBlackList: false,
    // 用户积分详情
    userPointsInfo: null,

    // 积分兑换规则
    COUPONS_RULES: [],
    FREE_PRODUCTS_RULES: [],
    THIRD_COUPONS_RULES: [],
    // 积分兑换规则 url模式
    COUPONS_RULES_URL: [],
    FREE_PRODUCTS_RULES_URL: [],
    THIRD_COUPONS_RULES_URL: [],

    // 已兑换券
    COUPONS_REDEEMED: [],
    FREE_PRODUCTS_REDEEMED: [],
    THIRD_COUPONS_REDEEMED: [],

    // Issued 第三方
    ISSEUED_THIRD_COUPONS_REDEEMED: [],

    // 抽奖活动
    LUCKY_ACTIVE: undefined,
};

const ecoReducer = (state: EcoState, action: EcoAction): EcoState => {
    const { type, payload } = action;

    switch (type) {
        case EcoTypes.changeBlackList:
            return { ...state, inBlackList: payload };
        case EcoTypes.GET_COUPONS_RULES:
            return { ...state, COUPONS_RULES: payload };
        case EcoTypes.GET_COUPONS_RULES_URL:
            return { ...state, COUPONS_RULES_URL: payload };
        case EcoTypes.GET_FREE_PRODUCTS_RULES:
            return { ...state, FREE_PRODUCTS_RULES: payload };
        case EcoTypes.GET_FREE_PRODUCTS_RULES_URL:
            return { ...state, FREE_PRODUCTS_RULES_URL: payload };
        case EcoTypes.GET_THIRD_COUPONS_RULES:
            return { ...state, THIRD_COUPONS_RULES: payload };
        case EcoTypes.GET_THIRD_COUPONS_RULES_URL:
            return { ...state, THIRD_COUPONS_RULES_URL: payload };
        case EcoTypes.GET_COUPONS_REDEEMED:
            return { ...state, COUPONS_REDEEMED: payload };
        case EcoTypes.GET_FREE_PRODUCTS_REDEEMED:
            return { ...state, FREE_PRODUCTS_REDEEMED: payload };
        case EcoTypes.GET_THIRD_COUPONS_REDEEMED:
            return { ...state, THIRD_COUPONS_REDEEMED: payload };
        case EcoTypes.GET_ISSUED_THIRD_COUPONS_REDEEMED:
            return { ...state, ISSEUED_THIRD_COUPONS_REDEEMED: payload };
        case EcoTypes.GET_ACTIVE_LIST:
            return { ...state, LUCKY_ACTIVE: payload };
        default:
            return state;
    }
};

export const EcoContext = createContext<{ state: EcoState; dispatch: React.Dispatch<EcoAction> }>({
    state: initState,
    dispatch: () => null,
});

const handleCouponsRules = async ({ locale, pathUrl, t, timezoneList }: any) => {
    let rewardRedeemRules = [];
    try {
        const res = await getRewardRedeemRule(locale, pathUrl);
        if (res?.code === '0') {
            const flatRules = res.data?.map((item: any) => {
                let minimum_rule = '';
                if (item?.prerequisite === 'PRICES') {
                    // 最低金额
                    const price = parseInt(item.prerequisiteRange);
                    const currencySymbol = item?.ruleWebsite?.currencySymbol || '';
                    const rangeConfig = ['uk', 'br', 'mx', 'ph'].includes(locale)
                        ? { price: currencySymbol + FormatMoney(price) }
                        : { price: FormatMoney(price) + currencySymbol };
                    const prerequisiteRange = t('minimum_price', rangeConfig);
                    minimum_rule = prerequisiteRange;
                }
                if (item?.prerequisite === 'QUANTITY') {
                    // 最低数量
                    const num = parseInt(item.prerequisiteRange);
                    const prerequisiteRange = t('minimum_num', { num });
                    minimum_rule = prerequisiteRange;
                }
                return {
                    ...item,
                    minimum_rule,
                    amount: item.ruleWebsite.amount,
                    currencySymbol: item.ruleWebsite.currencySymbol,
                    currency: item.ruleWebsite.currency,
                };
            });
            rewardRedeemRules = injectNotes(flatRules || [], locale, t, timezoneList);
        }
    } catch (err) {
        console.log(err);
    }

    return rewardRedeemRules;
};

const handleCouponsRedeemed = async ({ locale, t, timezoneList }: any) => {
    let rewardRedeemRules = [];
    try {
        const res = await getRewardRedeemCoupon(locale);
        if (res?.code === '0') {
            const flatRules = res.data?.map((item: any) => {
                let minimum_rule = '';
                if (item?.prerequisite === 'PRICES') {
                    // 最低金额
                    const price = parseInt(item.prerequisiteRange);
                    const currencySymbol = item?.ruleWebsite?.currencySymbol || '';
                    const prerequisiteRange = t('minimum_price', { price: currencySymbol + FormatMoney(price) });
                    minimum_rule = prerequisiteRange;
                }
                if (item?.prerequisite === 'QUANTITY') {
                    // 最低数量
                    const num = parseInt(item.prerequisiteRange);
                    const prerequisiteRange = t('minimum_num', { num });
                    minimum_rule = prerequisiteRange;
                }

                return {
                    ...item,
                    minimum_rule,
                };
            });
            rewardRedeemRules = injectNotes(flatRules || [], locale, t, timezoneList);
        }
    } catch (err) {
        console.log(err);
    }
    console.log('CouponsRedeemedrewardRedeemRule22222s--->>>', rewardRedeemRules);

    return rewardRedeemRules;
};

const asyncDispatch = (dispatch: Dispatch<EcoAction>) =>
    useCallback(async ({ type, payload }: EcoAction) => {
        switch (type) {
            case 'checkBlackList':
                const res = await checkBlacklist(payload.locale);
                if (res?.code !== '0') return message.error(res?.message);
                dispatch({
                    type: EcoTypes.changeBlackList,
                    payload: res.data?.inBlackList,
                });
                return;
            case 'getCouponsRules': // 查询积分兑换规则列表 - 优惠券
                const rewardRedeemRules = await handleCouponsRules(payload);

                if (payload.pathUrl) {
                    dispatch({
                        type: EcoTypes.GET_COUPONS_RULES_URL,
                        payload: rewardRedeemRules,
                    });
                } else {
                    dispatch({
                        type: EcoTypes.GET_COUPONS_RULES,
                        payload: rewardRedeemRules,
                    });
                }
                return;
            case 'getProductRules': // 查询积分兑换规则列表 - 实体产品
                queryFreeProductRuleList(payload.locale, payload.pathUrl).then((res) => {
                    if (res?.code === '0') {
                        // 过滤隐藏开关打开，且库存为0的优惠券
                        const list = res?.data?.filter((coupon: any) => {
                            const { stock, stockEnable } = coupon;
                            return !(!stockEnable && stock <= 0);
                        });
                        const freeProductRuleList = list?.map((coupon: any) => {
                            const noteList = coupon?.ruleDescription?.split('\n')?.filter((str: string) => !!str);
                            return {
                                ...coupon,
                                noteList,
                            };
                        });
                        if (payload.pathUrl) {
                            dispatch({
                                type: EcoTypes.GET_FREE_PRODUCTS_RULES_URL,
                                payload: freeProductRuleList,
                            });
                        } else {
                            dispatch({
                                type: EcoTypes.GET_FREE_PRODUCTS_RULES,
                                payload: freeProductRuleList,
                            });
                        }
                    }
                });
                return;
            case 'getThiredCouponRules': // 查询积分兑换规则列表 - 第三方优惠券
                queryThirdCouponRuleList(payload.locale, payload.pathUrl).then((res) => {
                    if (res?.code === '0') {
                        // 过滤隐藏开关打开，且库存为0的优惠券
                        const list = res?.data?.filter((coupon: any) => {
                            const { stock, stockEnable } = coupon;
                            return !(!stockEnable && stock <= 0);
                        });
                        const thiredCouponRules = list?.map((coupon: any) => {
                            const noteList = coupon?.ruleDescription?.split('\n')?.filter((str: string) => !!str);
                            return {
                                ...coupon,
                                noteList,
                            };
                        });
                        if (payload.pathUrl) {
                            dispatch({
                                type: EcoTypes.GET_THIRD_COUPONS_RULES_URL,
                                payload: thiredCouponRules,
                            });
                        } else {
                            dispatch({
                                type: EcoTypes.GET_THIRD_COUPONS_RULES,
                                payload: thiredCouponRules,
                            });
                        }
                    }
                });
                return;
            case 'getCouponsRedeemed': // 查询用户已兑换优惠券 -- 常规
                const couponsRedeemedList = await handleCouponsRedeemed(payload);

                dispatch({
                    type: EcoTypes.GET_COUPONS_REDEEMED,
                    payload: couponsRedeemedList,
                });
                return;
            case 'getProducts': // 查询用户已兑换优惠券 -- 实体产品
                queryFreeProductList(payload.locale).then((res) => {
                    if (res?.code === '0') {
                        const FreeProducts = res?.data?.map((coupon: any) => {
                            const noteList = coupon?.ruleDescription?.split('\n')?.filter((str: string) => !!str);
                            return {
                                ...coupon,
                                noteList,
                            };
                        });
                        dispatch({
                            type: EcoTypes.GET_FREE_PRODUCTS_REDEEMED,
                            payload: FreeProducts || [],
                        });
                    }
                });
                return;
            case 'getThiredCoupons': // 查询用户已兑换优惠券 -- 第三方优惠券
                queryThirdCouponList(payload.locale).then((res) => {
                    if (res?.code === '0') {
                        const thirdCoupons = res?.data?.map((coupon: any) => {
                            const noteList = coupon?.ruleDescription?.split('\n')?.filter((str: string) => !!str);
                            return {
                                ...coupon,
                                noteList,
                            };
                        });
                        dispatch({
                            type: EcoTypes.GET_THIRD_COUPONS_REDEEMED,
                            payload: thirdCoupons || [],
                        });
                    }
                });
                return;
            case 'getActives': // 查询活动列表
                const { pathUrl, locale } = payload;
                queryActivetyList(locale, pathUrl).then((res) => {
                    if (res?.code === '0') {
                        // 过滤出可用的活动
                        const active = res?.data?.[0];
                        dispatch({
                            type: EcoTypes.GET_ACTIVE_LIST,
                            payload: active || [],
                        });
                    }
                });
                return;
            case 'getIssuedThiredCoupons': // 查询用户已兑换优惠券 -- 第三方优惠券
                queryIssuedThirdCouponList(payload.locale).then((res) => {
                    if (res?.code === '0') {
                        const IssuedThirdCoupons = res?.data?.map((coupon: any) => {
                            const noteList = coupon?.ruleDescription?.split('\n')?.filter((str: string) => !!str);
                            return {
                                ...coupon,
                                noteList,
                            };
                        });
                        dispatch({
                            type: EcoTypes.GET_ISSUED_THIRD_COUPONS_REDEEMED,
                            payload: IssuedThirdCoupons || [],
                        });
                    }
                });
                return;
            default:
                dispatch({ type, payload });
        }
    }, []);

export function EcoProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(ecoReducer, initState);
    return <EcoContext.Provider value={{ state, dispatch: asyncDispatch(dispatch) }}>{children}</EcoContext.Provider>;
}

export const useStore = () => {
    const store = useContext(EcoContext);
    const state = store.state;
    return state;
};

export const useDispatch = () => {
    const store = useContext(EcoContext);
    const dispatch = store.dispatch;
    return dispatch;
};
